import Chart from './src/chart.vue'

export default Chart
